<style scoped>
.this__close {
  position: absolute;
  top: 30px;
  right: 30px;
}
</style>
<template>
  <div>
    <h2
      class="demo__weight--600 demo__font--20 demo__color--black demo__padding-bottom--0"
    >
      {{ $t("emailVerify.title") }}
    </h2>
    <div
      class="demo__margin-top--16 demo__color--black demo__font--16 demo__weight--400"
    >
      {{ $t("emailVerify.desc1") }}
      <b>{{ form.email }}</b>
      {{ $t("emailVerify.desc2") }}
    </div>
    <!-- <div
      class="demo__font--16 demo__weight--600 demo__color--black demo__flex demo__flex-middle demo__pointer demo__margin-top--24"
      @click="toAuth"
    >
      <div>
        {{ $t("Submit") }}
      </div>
      <i class="fa-regular fa-chevron-right demo__margin-left--12"></i>
    </div> -->
    <i
      class="fa-solid fa-xmark-large fa-lg this__close"
      @click="closeModal"
    ></i>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
    regResult: {
      required: false,
      type: String,
      default: undefined,
    },
  },
  created() {
    this.$accessModule("step4", this);
  },
  mounted() {
    window?.localStorage?.setItem(
      "lastRegisteredForm",
      JSON.stringify(this.form)
    );
  },
  methods: {
    closeModal() {
      this.$store.dispatch("updateAuthModalStatus", undefined);
    },
  },
};
</script>
